module.exports = "<div class=\"articlePageHeader\">\n    {{headerInput}}\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/ppeters/filmCritClient/src/app/components/pageSectionHeader/pageSectionHeader.component.html
// module id = ../../../../../src/app/components/pageSectionHeader/pageSectionHeader.component.html
// module chunks = main